export default "__VITE_ASSET__Bi_Tbs9F__"